import { authApi, merchantApi } from "@api";
import {
    ComponentHeaderAuth,
    ComponentHome,
    ComponentPdpa,
    ComponentQRcode,
    StyledContainerHome,
    StyledHome,
} from "@components";
import {
    PATH_PROFILE,
    PATH_TIER_DETAIL,
    PATH_WELCOME,
    enumExternalAuthType,
    enumExternalMethod,
    enumNavigation,
} from "@configs";
import { ILineLogin } from "@interfaces";
import liff from "@line/liff";

import { ModuleHistory, ModulesBenefit, ModulesCoupon, ModulesReward } from "@modules";
import {
    selectAuth,
    selectMerchant,
    selectNotSaveLocal,
    setExternalLogin,
    setNavigationType,
    store,
} from "@redux";
import PostForm from "@Rocket-Innovation/components/app/crm/client/post-form/components/PostForm";
import CacheStore from "@Rocket-Innovation/components/store/CacheStore";
import UserStore from "@Rocket-Innovation/components/store/UserStore";
import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { formatMessage, newFormatMessage, useNotify } from "@utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { ComponentPopupHomePage } from "src/Components/PopupHomePage";
import LoadOverlay from "src/Components/shared/LoadOverlay";
import { useFullScreen } from "src/Helpers/useFullscreen";
import useRedirect from "src/Store/useRedirect";

function useErrorBoundary() {
    const [error, setError] = useState<boolean>(false);

    useEffect(() => {
        const handleError = () => {
            setError(true);
        };
        window.addEventListener("error", handleError);
        if (liff.isInClient()) {
            liff._addListener("error", handleError);
        }

        return () => {
            window.removeEventListener("error", handleError);
            if (liff.isInClient()) {
                liff._removeListener("error", handleError);
            }
        };
    }, []); // useEffect จะทำงานเพียงครั้งเดียวเมื่อ Component โหลด

    // ส่งกลับ state ของข้อผิดพลาด
    return error;
}

export const PageHome = () => {
    //page hook
    const eventError = useErrorBoundary();
    const history = useHistory();
    const dispatch = useDispatch();
    const { error, success } = useNotify();
    const { t } = useTranslation();
    //page redux
    const { userInfo, auth } = useSelector(selectAuth);
    const accessToken = auth ?? UserStore((s: any) => s.accessToken);
    const { themes, memberShipTiers } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const signUpMethod = merchant?.signUpSettings?.signUpMethod;
    const { navigationType } = useSelector(selectNotSaveLocal);
    //page state
    const [showQrCode, setShowQrCode] = useState<boolean>(false);
    const isReady = CacheStore((state: any) => state.isReady);
    const useDrawer = UIStore((state: any) => state.useDrawer);
    const usePostForm = UIStore((state: any) => state.usePostForm);

    const token = store.getState().auth.auth?.accessToken;
    let getParams = new URLSearchParams(window.location.search);
    let queryParams: {
        code: string;
        state: string;
    } = {
        code: getParams.get("code") || "",
        state: getParams.get("state") || "",
    };
    let check = false;

    const { app, store_id } = useRedirect();

    const userAgent = navigator.userAgent;
    const lowerText: string = userAgent.toLowerCase();

    const handleToggleUnder = (values: enumNavigation) => {
        dispatch(setNavigationType(values));
    };

    const handleToggleQrCode = () => {
        setShowQrCode(!showQrCode);
    };

    const handleSwitchUserSetting = () => {
        // history.push(PATH_USER_SETTING);
        history.push(PATH_PROFILE);
    };

    const handleSwitchTier = () => {
        history.push(PATH_TIER_DETAIL);
    };

    const handleInitalQrCode = () => {
        setShowQrCode(false);
    };

    const openLiff = async () => {
        const liffUrl = await liff.permanentLink.createUrlBy(window.location.href);
        window.location.href = liffUrl;
    };
    const isTechDomain = () => {
        const currentURL = window.location.href;
        return currentURL.includes(".app");
    };
    const handleLogin = async () => {
        await null;
        console.log("handleLogin in /line-login");
        // alert("handleLogin in /line-login");
        let getAccToken: any = "";
        let getTokenId: any = "";
        // console.log('profile', profile);
        // console.log('token', getAccToken);
        // console.log('id', getTokenId);

        if (queryParams.code) {
            console.log("handleLogin if");
            // const lineState = JSON.parse(queryParams?.state as string) as ILineState;
            if (
                check
                // lineState.type === enumExternalAuthType.LINK_LINE
            ) {
                (async () => {
                    const lineLoginData: ILineLogin = {
                        token: getAccToken || "",
                        refreshToken: "",
                        tokenId: getTokenId || "",
                    };
                    try {
                        await authApi.updateLine(lineLoginData);
                        success(t("message.update_link_line_success"));
                    } catch (err: any) {
                        if (err.response) {
                            error(formatMessage(err.response));
                        } else {
                            error(t("message.try_again_text"));
                        }
                    } finally {
                        console.log("why user setting ?");
                        // history.push(PATH_USER_SETTING);
                    }
                })();
                //
                return;
            } else if (queryParams.state) {
                dispatch(
                    setExternalLogin({
                        type:
                            signUpMethod === enumExternalMethod.LINE
                                ? enumExternalMethod.LINE
                                : enumExternalMethod.LINEOA_TEL,
                        isSignUp: false,
                        line: {
                            code: queryParams.code.toString(),
                            state: enumExternalAuthType.LOGIN,
                        },
                    })
                );
                localStorage.removeItem("LINE_LOGIN_SUCCESS");
                // history.push("/sign-in");
                history.push("/");
                console.log("line login home");
            } else {
                // dispatch(logout());
                dispatch(
                    setExternalLogin({
                        type:
                            signUpMethod === enumExternalMethod.LINE
                                ? enumExternalMethod.LINE
                                : enumExternalMethod.LINEOA_TEL,
                        isSignUp: false,
                        line: {
                            code: "new line login",
                            state: enumExternalAuthType.LOGIN,
                        },
                    })
                );
                localStorage.removeItem("LINE_LOGIN_SUCCESS");
                // history.push("/sign-in");
                history.push("/");
                // sessionStorage.removeItem("LINE_LOGIN_SUCCESS");
                // history.push("/sign-in");
            }
        } else {
            console.log("handleLogin else");
            // alert("handleLogin else");
            localStorage.removeItem("LINE_LOGIN_SUCCESS");
            history.push("/");
            // history.push("/sign-in");
            // dispatch(
            //     setExternalLogin({
            //         type:
            //             signUpMethod === enumExternalMethod.LINE
            //                 ? enumExternalMethod.LINE
            //                 : enumExternalMethod.LINEOA_TEL,
            //         isSignUp: false,
            //         line: {
            //             code: "new line login",
            //             state: enumExternalAuthType.LOGIN,
            //         },
            //     })
            // );
            // localStorage.removeItem("LINE_LOGIN_SUCCESS");
            // history.push("/sign-in");
            // sessionStorage.removeItem("LINE_LOGIN_SUCCESS");
            // history.push("/sign-in");
        }
    };

    const checkBrowser = async () => {
        // if (!merchant) history.replace(PATH_WELCOME);
        // if (
        //     sessionStorage.getItem("DISABLE_APP_ROUTE") === "true" &&
        //     localStorage.getItem("LINE_LOGIN_SUCCESS") !== "true"
        // ) {
        //     history.replace(PATH_WELCOME);
        // }
        // alert(`checkBrowser in /home ${localStorage.getItem("LINE_LOGIN_SUCCESS")}`);
        console.log("checkBrowser in /home");
        await null;
        const userAgent = navigator.userAgent;
        let lowerText: string = userAgent.toLowerCase();

        if (
            (merchant?.signUpSettings?.signUpMethod === enumExternalMethod.LINEOA_TEL ||
                merchant?.signUpSettings?.signUpMethod === enumExternalMethod.LINE) &&
            localStorage.getItem("LINE_LOGIN_SUCCESS") === "true"
        ) {
            console.log(`liff.init signin, ${localStorage.getItem("LINE_LOGIN_SUCCESS")}`);
            sessionStorage.setItem("DISABLE_APP_ROUTE", "true");
            if (isReady) handleLogin();
        }
        if (
            lowerText.includes("line")
            // && lowerText.includes('android')
        ) {
            if (
                (merchant?.signUpSettings?.signUpMethod === enumExternalMethod.LINEOA_TEL ||
                    merchant?.signUpSettings?.signUpMethod === enumExternalMethod.LINE) &&
                (token || sessionStorage.getItem("SING_UP") === "true")
                // && sessionStorage.getItem("LINE_LOGIN_SUCCESS") !== "true"
            ) {
                if (isReady) sessionStorage.removeItem("SING_UP");
            }
        }
    };
    const checkFirstPage = () => {
        console.log("checkFirstPage in /home");
        let setFirstPage = sessionStorage.getItem("FIRST_PAGE");
        let onSignUp = sessionStorage.getItem("SING_UP");
        if (!setFirstPage && !onSignUp && token) {
            if (
                merchant?.themes?.basicThemeSetting?.choiceFirstPage?.choiceType &&
                merchant?.themes?.basicThemeSetting?.choiceFirstPage?.choiceType === "default"
            ) {
                // history.push("/");
                sessionStorage.setItem("FIRST_PAGE", "true");
            } else if (
                merchant?.themes?.basicThemeSetting?.choiceFirstPage?.choiceType &&
                merchant?.themes?.basicThemeSetting?.choiceFirstPage?.choiceType === "custom"
            ) {
                if (
                    merchant?.themes?.basicThemeSetting?.choiceFirstPage?.url &&
                    merchant?.themes?.basicThemeSetting?.choiceFirstPage?.url[0] === "/"
                ) {
                    history.push(merchant?.themes?.basicThemeSetting?.choiceFirstPage?.url);
                } else if (
                    merchant?.themes?.basicThemeSetting?.choiceFirstPage?.url &&
                    merchant?.themes?.basicThemeSetting?.choiceFirstPage?.url[0] !== "/"
                ) {
                    window.open(merchant?.themes?.basicThemeSetting?.choiceFirstPage?.url, "_self");
                }
                sessionStorage.setItem("FIRST_PAGE", "true");
            }
        }
    };

    // const checkSurvey = () => {
    //     const survey = localStorage.getItem("SURVEY");
    //     let onSignUp = sessionStorage.getItem("SING_UP");
    //     if (survey && !onSignUp && userInfo && token) {
    //         history.push(PATH_SURVEY + "/" + survey);
    //     }
    // };
    useEffect(() => {
        let onSignUp = sessionStorage.getItem("SING_UP");
        if (!onSignUp && localStorage.getItem("QRCODE") && userInfo && token) {
            merchantApi
                .qrClaimPoint({
                    merchantId: userInfo?.merchantId || "",
                    userId: userInfo?.contact?.userId || "",
                    productOrderId: localStorage.getItem("QRCODE"),
                })
                .then((res) => {
                    success(newFormatMessage(res));
                    localStorage.removeItem("QRCODE");
                    // history.push(PATH_HOME);
                })
                .catch((err) => {
                    // error(err.message);
                    error(newFormatMessage(err.response));
                    localStorage.removeItem("QRCODE");
                    // history.push(PATH_HOME);
                });
        }
        // checkSurvey();
    }, [userInfo]);

    useEffect(() => {
        if (!isReady) return;

        checkBrowser();
        checkFirstPage();

        if (
            (merchant?.signUpSettings?.signUpMethod === enumExternalMethod.LINEOA_TEL ||
                merchant?.signUpSettings?.signUpMethod === enumExternalMethod.LINE) &&
            !token &&
            !sessionStorage.getItem("DISABLE_APP_ROUTE") &&
            !localStorage.getItem("LINE_LOGIN_SUCCESS")
        ) {
            console.log("commented history.replace(PATH_WELCOME);");
            // history.replace(PATH_WELCOME);
            // alert("WEL 1");
        }

        // alert(sessionStorage.getItem("DISABLE_APP_ROUTE"));
        // alert(localStorage.getItem("LINE_LOGIN_SUCCESS"));
    }, [isReady]);

    useEffect(() => {
        if (eventError) {
            if (
                (merchant?.signUpSettings?.signUpMethod === enumExternalMethod.LINEOA_TEL ||
                    merchant?.signUpSettings?.signUpMethod === enumExternalMethod.LINE) &&
                !token &&
                !sessionStorage.getItem("DISABLE_APP_ROUTE") &&
                !localStorage.getItem("LINE_LOGIN_SUCCESS") &&
                liff.isInClient()
            ) {
                console.log("AAA");
                history.replace(PATH_WELCOME);
                // alert("WEL 2");
            }
        }
    }, [error]);

    const clearAllCookies = () => {
        // Get all cookies
        const cookies = document.cookie.split(";");

        // Iterate through each cookie and clear it
        cookies.forEach((cookie) => {
            const [name] = cookie.split("=");
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        });
    };

    const clearAllCacheStorage = async () => {
        try {
            const cacheNames = await window.caches.keys();
            await Promise.all(cacheNames.map((cacheName) => window.caches.delete(cacheName)));
            console.log("All cache storage cleared successfully.");
        } catch (error) {
            console.error("Error clearing cache storage:", error);
        }
    };
    useEffect(() => {
        // console.log("userInfo usePostForm ==>", userInfo);
        const isRegistered = userInfo?.contact?.firstName && userInfo?.contact?.lastName;
        if (isRegistered) {
            console.log("userInfo usePostForm ==>", userInfo);
            UIStore.setState({
                useDrawer: usePostForm,
                drawerContent: (
                    <span
                        style={{
                            color: "black",
                        }}
                    >
                        <PostForm memberTypeId={userInfo?.contact?.memberTypeNameId!} />
                    </span>
                ),
            });
        }
    }, [userInfo, usePostForm]);

    const render = () => {
        switch (navigationType) {
            case enumNavigation.USER_POINT:
                return <ModulesReward />;
            case enumNavigation.BENEFIT:
                return <ModulesBenefit />;
            case enumNavigation.COUPON:
                return <ModulesCoupon under={navigationType} />;
            case enumNavigation.HISTORY:
                return <ModuleHistory />;
            case enumNavigation.COUPON_MERCHANT:
                return <ModulesCoupon under={navigationType} />;
            default:
                return <></>;
        }
    };

    const renderCorporateUi = () => {
        if (merchant?.advanceSettings?.advanceFeature?.isCorporateUi) {
            return null;
        } else {
            return (
                <>
                    <StyledContainerHome className="home-nab-detail">
                        {render()}
                    </StyledContainerHome>
                </>
            );
        }
    };

    const fullHeight = useFullScreen();

    if (!CacheStore.getState().isReady && !lowerText.includes("android"))
        return (
            <LoadOverlay active={true} text="Please wait...">
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: fullHeight,
                    }}
                />
            </LoadOverlay>
        );

    return (
        <ComponentHeaderAuth handleInitalQrCode={handleInitalQrCode}>
            <StyledHome mainColor={themes?.themeColor!} style={{ height: fullHeight }}>
                {!showQrCode && (
                    <>
                        <ComponentHome
                            under={navigationType}
                            handleToggleUnder={handleToggleUnder}
                            userInfo={userInfo}
                            memberShipTiers={memberShipTiers || []}
                            themeColor={themes?.themeColor!}
                            handleToggleQrCode={handleToggleQrCode}
                            handleSwitchUserSetting={handleSwitchUserSetting}
                            handleSwitchTier={handleSwitchTier}
                            // handleCoupon={handleCoupon}
                        />
                        {renderCorporateUi()}
                    </>
                )}
                {showQrCode && <ComponentQRcode handleToggleQrCode={handleToggleQrCode} />}
                {(token || accessToken) && <ComponentPdpa />}
                {!useDrawer && (
                    <ComponentPopupHomePage accessToken={accessToken} usePostForm={usePostForm} />
                )}
            </StyledHome>
        </ComponentHeaderAuth>
    );
};
